import { Countries } from '../../../utils/countries-enum';
import { DynamicComponentManifest } from '../../../dynamic-component-loader/dynamic-component-manifest';
import { DynamicArrayGenerator } from '../../../utils/dynamic-array-generator';

export class IndonesiaManifest {
  da: DynamicArrayGenerator;
  constructor() {
    this.da = new DynamicArrayGenerator();
  }
  public getIDNManifest(): DynamicComponentManifest[] {
    const components = [
      {
        'key': 'tax-fee',
        'module': 'GlobalModule'
      },
      {
        'key': 'company-names',
        'module': 'GlobalModule'
      },
      {
        'key': 'gst-fee-field',
        'module': 'GlobalModule'
      },
      {
        'key': 'invoice-header',
        'module': 'GlobalModule'
      },
      {
        'key': 'gws-entity-location',
        'module': 'GlobalModule'
      },
      {
        'key': 'billing-information',
        'module': 'GlobalModule'
      },
      {
        'key': 'tax-fee-percent',
        'module': 'GlobalModule'
      }
    ];
    // tslint:disable-next-line: no-use-before-declare
    return this.da.generateManifest(components, Countries.Indonesia);
  }
}
